import { NavLink } from 'react-router-dom';
import './TopNav.css';

export function TopNav() {
  return (
    <nav className="top-nav">
      <div className="nav-brand">Property Dashboard</div>
      <div className="nav-links">
        <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
          Properties
        </NavLink>
        <NavLink to="/markets" className={({ isActive }) => isActive ? 'active' : ''}>
          Markets
        </NavLink>
        <NavLink to="/market-analysis" className={({ isActive }) => isActive ? 'active' : ''}>
          Rental Analysis
        </NavLink>
        <NavLink to="/crawl" className={({ isActive }) => isActive ? 'active' : ''}>
          Crawl
        </NavLink>
        <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>
          Admin
        </NavLink>
      </div>
    </nav>
  );
}
